module.exports = __webpack_public_path__ + "static/media/nike-glyphs.7cb650e4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/NikeGlyphs/nike-glyphs.svg
// module id = 805
// module chunks = 0